// Next
import Image from 'next/image';

// Contentful
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { RENDER_DOCUMENT_OPTIONS, imageLoader } from '../../helpers/contentful';

const InvestorsOverview = (props) => {
  const { title, description, items } = props;

  return (
    <div className="InvestorsOverview">
      <div className="InvestorsOverview-inner">
        <div className="InvestorsOverview-wrapper">
          <div className="InvestorsOverview-container">
            {title && (
              <div className="InvestorsOverview-header">
                <h2 className="InvestorsOverview-title">{documentToReactComponents(title, RENDER_DOCUMENT_OPTIONS)}</h2>
                {description && (
                  <div className="InvestorsOverview-description">
                    {documentToReactComponents(description, RENDER_DOCUMENT_OPTIONS)}
                  </div>
                )}
              </div>
            )}
            {items && (
              <div className="InvestorsOverview-content">
                {items.map((item, index) => (
                  <div className="InvestorsOverview-item" key={`InvestorsOverview-item-${index}`}>
                    <Image
                      layout="fill"
                      lazyBoundary="500px"
                      objectFit="contain"
                      objectPosition="center"
                      sizes="300px"
                      loader={imageLoader}
                      src={`https:${item.src}`}
                      alt={`Logo ${item.alt}`}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestorsOverview;
